import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = { class: "mt-32" }
const _hoisted_3 = { class: "request-support-box bg-white shadow-md p-6 rounded-md mt-16 w-full max-w-[800px]" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "w-full max-w-[800px] mt-8 space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion = _resolveDirective("motion")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "request-support flex flex-col items-center w-full pb-20",
    initial: _ctx.initialMotion,
    enter: _ctx.enterMotion
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Banner, {
        image: "virtual-assistant.svg",
        subtitle: 'Teve algum problema na plataforma? Entre em contato com nosso Suporte, será um prazer ajudá-lo.',
        subtitleEN: 'Did you have any problems on the platform? Contact our Support, it will be a pleasure to help you',
        title: 'Suporte',
        titleEN: 'Support'
      }, null, 8, ["subtitle"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.optionChoice,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.optionChoice) = $event)),
        options: _ctx.supportOptions,
        optionLabel: "name",
        optionValue: "name",
        placeholder: 
          _ctx.$t('labels.generic', {
            pt: 'Selecionar problema',
            en: 'Select problem',
          })
        ,
        class: _normalizeClass(`dropdown w-full ${_ctx.v$.optionChoice.$error ? 'p-invalid' : ''}`)
      }, null, 8, ["modelValue", "options", "placeholder", "class"]),
      _createVNode(_component_Errors, {
        errors: _ctx.v$.optionChoice.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Textarea, {
          modelValue: _ctx.msg,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.msg) = $event)),
          rows: "5",
          cols: "30",
          class: _normalizeClass(_ctx.v$.msg.$error ? 'p-invalid' : '')
        }, null, 8, ["modelValue", "class"]),
        _createVNode(_component_Errors, {
          errors: _ctx.v$.msg.$errors
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        label: _ctx.$t('labels.generic', { pt: 'Enviar', en: 'Send' }),
        class: _normalizeClass(`w-1/4 ${_ctx.msg && _ctx.optionChoice ? 'btn-primary' : 'btn-disabled'}`),
        disabled: !_ctx.msg || !_ctx.optionChoice,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendEmail()))
      }, null, 8, ["label", "class", "disabled"])
    ])
  ], 8, _hoisted_1)), [
    [_directive_motion]
  ])
}